import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { installStaleBundleListeners } from "@/lib/staleBundleRecovery";

// Catch stale-bundle errors that fire OUTSIDE React's render tree — e.g. a
// failed dynamic import resolving as an unhandled rejection during route
// transitions. Must run before the first render so we never miss the
// earliest chunk load.
installStaleBundleListeners();

createRoot(document.getElementById("root")!).render(<App />);

// We previously shipped vite-plugin-pwa, which registered a caching service
// worker at /sw.js on every production visit. That worker outlived its
// usefulness: after deploys it kept serving an older index.html pointing at
// deleted chunks, which broke /account, /demo, and /menus/:id/list. We've
// removed the plugin and ship a kill-switch worker (public/sw.js) that
// unregisters itself; this client-side cleanup belt-and-braces the same fix
// for browsers that never re-fetch /sw.js.
if (typeof window !== "undefined" && "serviceWorker" in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((regs) => {
      regs.forEach((r) => r.unregister());
    })
    .catch(() => {
      // non-fatal — older browsers may not allow enumeration
    });
}
